import { NgModule } from "@angular/core";
import { EdpDashboardSimpleGridComponent } from "./edp-dashboard-simple-grid.component";
import { SharedModule } from "@edp-components/shared.module";
import { EdpEsWidgetOrderModule } from "@edp-components/ES/edp-es-widget-order/edp-es-widget-order.module";
import { EdpWidgetSolarModule } from "@edp-components/ES/edp-widget-solar/edp-widget-solar.module";
@NgModule({
    declarations: [EdpDashboardSimpleGridComponent],
    imports: [SharedModule, EdpEsWidgetOrderModule, EdpWidgetSolarModule],
    exports: [EdpDashboardSimpleGridComponent],
})
export class EdpDashboardSimpleGridModule {}
